export default "__VITE_ASSET__CVuud0Xf__"